import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ formComponents }: ComposedTheme) => ({
  dark: {},
  error: {},
  root: {
    ...formComponents.error,
    '&$dark': {
      color: formComponents.dark.color,
    },
    '&$error': {
      '&$dark': {
        color: formComponents.dark.error.color,
      },
      color: formComponents.error.color,
    },
    color: formComponents.label.color,
    margin: [6, 0, 0, 'auto'],
    paddingLeft: 6,
  },
});

export default createUseStyles(styles);
